import React from 'react';
import PropTypes from 'prop-types';
import TimePicker from 'rc-time-picker';
import moment from 'moment';

import 'rc-time-picker/assets/index.css';

const TimeInput = (
  { input, label, labelMeta, meta, placeholder, disabledHours, disabledMinutes },
  context
) => {
  const onOpenHandler = isOpen => {
    isOpen ? input.onFocus(true) : input.onBlur(true);
  };

  return (
    <div className="form-group">
      {label && labelMeta && (
        <div className="row">
          <div className="col">
            <label>{label}</label>
          </div>
          <div className="col-auto">{labelMeta}</div>
        </div>
      )}
      {label && !labelMeta && <label>{label}</label>}
      <TimePicker
        value={input.value}
        placeholder={placeholder}
        showSecond={false}
        className="d-block"
        onChange={value => {
          // "value" returned here must not be null, (there is a bug where time pucker returns next value as local time instead of UTC) so we reset the timer to 00:00 in moment utc mode
          value = value ? moment.utc(value) : moment.utc('2000-01-01 00:00');
          input.onChange({ value });
        }}
        onOpen={onOpenHandler}
        onClose={onOpenHandler}
        disabledHours={disabledHours}
        disabledMinutes={disabledMinutes}
      />
      <div className="invalid-feedback d-block">
        {' '}
        {meta.touched &&
          ((meta.error && <span>{context.t(meta.error)}</span>) ||
            (meta.warning && <span>{context.t(meta.warning)}</span>))}
      </div>
    </div>
  );
};

TimeInput.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default TimeInput;
